<template>
    <main role="main" class="py-4">
      <b-container>
        <h4>{{ $t("updateApiConfig") }}</h4>
  
        <div v-if="isLoading" class="text-center py-5"><b-spinner type="glow"/></div>
  
        <b-form class="mt-4 max-width-700" @submit.prevent="submitForm">
          <!--<b-form-row>
            <b-form-group class="col-lg-6">
              <template v-slot:label>
                Tên gói cước <span class="text-danger">*</span>
              </template>
              <b-form-input type="text" required minlength="2" maxlength="20" v-model="name" />
            </b-form-group>
            <b-form-group class="col-lg-6" label="Loại gói cước">
              <b-form-select v-model="packageType" :options="packageTypeOptions" />
            </b-form-group>
          </b-form-row>-->
  
          <b-form-row>
            <b-form-group class="col-lg-12">
              <template v-slot:label>
                URL <span class="text-danger">*</span>
              </template>
              <b-form-input type="text" minlength="1" v-model="apiUrl" />
            </b-form-group>
          </b-form-row>
          <b-form-row>
            <b-form-group class="col-lg-12">
              <template v-slot:label>
                Secret Key
              </template>
              <b-form-input type="text" required minlength="2" v-model="apiSecret" />
            </b-form-group>
          </b-form-row>  
          <b-form-row>
            <b-form-group class="col-lg-6">
              <template v-slot:label>
                {{ $t("maximumNumberOfParticipantsInMeeting") }} <span class="text-danger">*</span>
              </template>
              <b-form-input required type="number" min="2" max="1000" v-model="maxParticipants" />
            </b-form-group>
            <b-form-group class="col-lg-6" label="." label-class="text-white">
              <b-form-radio-group buttons button-variant="outline-primary" class="w-100"
                                  v-model="maxParticipants"
                                  :options="maximumNumberOfParticipantsInMeetingOptions" />
            </b-form-group>
          </b-form-row>
  
          <b-form-row>
            <b-form-group class="col-lg-6">
              <template v-slot:label>
                {{ $t("numberOfMeetingsPerMonth") }} <span class="text-danger">*</span>
              </template>
              <b-form-input required type="number" min="1" max="100000" v-model="maxMeetings" />
            </b-form-group>
            <b-form-group class="col-lg-6" label="." label-class="text-white">
              <b-form-radio-group buttons button-variant="outline-primary" class="w-100"
                                  v-model="maxMeetings" :options="numberOfMeetingsPerMonthOptions" />
            </b-form-group>
          </b-form-row>

          <b-form-row class="mt-2 mb-4">
            <b-form-group class="col-lg-6" :label="$t('activeStatus')">
              <b-form-radio-group required :options="activeOptions" v-model="status" />
            </b-form-group>
          </b-form-row>
  
          <div class="text-center">
            <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
            <!--<b-button type="button" @click="goBackToList">Test go back</b-button>-->
          </div>
        </b-form>
  
      </b-container>
    </main>
  </template>
  
<style lang="scss" scoped></style>
  
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _ from "lodash";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import BaseComponent from "@/components/BaseComponent";

@Component
export default class EditApiConfig extends BaseComponent {

    id: number;
    apiUrl: any;
    apiSecret: any;
    coreType: any;
    description: any;
    maxParticipants: number = null;;
    maxMeetings: number = null;;
    status: number = 1;
    packageStatusOptions = [
        { value: 1, text: this.$t("demo").toString() },
        { value: 2, text: this.$t("trial").toString() },
        { value: 3, text: this.$t("testing").toString() },
        { value: 4, text: this.$t("official").toString() },
    ];

    maximumNumberOfParticipantsInMeetingOptions = [50, 100, 300, 500, 1000];
    maximumNumberOfParticipantsInMeeting: number = null;

    numberOfMeetingsPerMonthOptions = [100, 300, 500, 1000];
    numberOfMeetingsPerMonth: number = null;

    price: number = null;

    activeOptions = [
        { text: this.$t("yes").toString(), value: 1 },
        { text: this.$t("no").toString(), value: 0 },
    ];

    isLoading = false;
    isSubmitting = false;


    mounted() {
        this.id = +this.$route.params.id;
        this.fetchPlan();
    }


    async fetchPlan() {
        try {
            this.isLoading = true;
            const apiConfig = await subscriptionPlanService.detailCorePlanType(this.id);

            this.apiUrl = apiConfig.apiUrl;
            this.apiSecret = apiConfig.apiSecret;
            this.coreType =  apiConfig.coreType;
            this.description = apiConfig.description;
            this.maxParticipants = apiConfig.maxParticipants;
            this.maxMeetings = apiConfig.maxMeetings;
            this.status = apiConfig.active;

        } catch (e) {
            this.toastError(e);

        } finally {
            this.isLoading = false;
        }
    }

    async submitForm() {
        try {
            this.isSubmitting = true;

            const data = {
              id: this.id,
              apiUrl: this.apiUrl,
              apiSecret: this.apiSecret,
              coreType: this.coreType,
              description: this.description,
              maxParticipants: +this.maxParticipants,
              maxMeetings: +this.maxMeetings,
              active :this.status
            };

            await subscriptionPlanService.updateCorePlanType(data);
            this.goBackToList();

        } catch (e) {
            this.toastError(e);

        } finally {
            this.isSubmitting = false;
        }
    }

    goBackToList() {
        this.$router.push("/admin-settings/manage-config");
        this.toastSuccessDelay(this.$t("updateApiConfigSuccessful").toString());
    }

}
</script>
  